export interface TopicTimelineItem {
  time: string;
  text: string;
}

export interface TopicViewpoint {
  side: string;
  title: string;
  desc: string;
}

export interface TopicComment {
  id: string;
  user: string;
  stance: string;
  content: string;
  time: string;
  likes: number;
}

export interface Topic {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  heat: number;
  summary: string;
  tags: string[];
  cover: string;
  publishedAt: string;
  evolveHours: number;
  stats: { support: number; oppose: number; neutral: number };
  timeline: TopicTimelineItem[];
  viewpoints: TopicViewpoint[];
  comments: TopicComment[];
}

export const topics: Topic[] = [
  {
    id: 'variety-show-editing',
    title: '综艺镜头分配引争议：观众热议剪辑是否公平',
    category: '影视综艺',
    categorySlug: 'screen',
    heat: 1820400,
    summary:
      '一档热播竞技综艺最新一期播出后，部分观众认为几位嘉宾的镜头时长差异明显，质疑剪辑存在节奏倾斜。节目组回应称剪辑以叙事完整性为先，讨论随之从"镜头多少"转向"真人秀到底该不该讲公平"。',
    tags: ['综艺', '剪辑', '镜头分配', '讨论现场'],
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20studio%20spotlight%20beams%20in%20warm%20orange%20and%20amber%20tones%20on%20soft%20cream%20backdrop%2C%20minimal%20geometric%20shapes%2C%20editorial%20poster%20style%2C%20no%20text&width=800&height=500&seq=topic-variety-edit-01&orientation=landscape',
    publishedAt: '2026-09-11',
    evolveHours: 26,
    stats: { support: 42, oppose: 45, neutral: 13 },
    timeline: [
      { time: '09-10 20:00', text: '新一期节目播出，社交平台出现关于镜头时长的对比截图。' },
      { time: '09-10 22:30', text: '相关话题进入热榜，讨论从"镜头分配"扩散到"剪辑逻辑"。' },
      { time: '09-11 09:00', text: '节目组发布回应，强调剪辑服务于叙事，不针对任何嘉宾。' },
      { time: '09-11 14:00', text: '多位从业者发文科普综艺后期流程，讨论转向行业常识。' },
    ],
    viewpoints: [
      { side: '正方', title: '镜头应尽量均衡', desc: '认为真人秀属于群像节目，嘉宾付出接近，镜头过于倾斜会影响观感与公平感。' },
      { side: '反方', title: '叙事优先于平均', desc: '认为剪辑要服务于故事线，强行平均会让节目节奏拖沓，不应简单按时长衡量。' },
      { side: '中立', title: '缺乏统一标准', desc: '指出综艺剪辑行业尚缺公开透明的衡量方式，观众与制作方对"公平"理解不同。' },
    ],
    comments: [
      { id: 'c1', user: '追综小分队', stance: '正方', content: '不是要求一模一样，但差距大到出戏就有点说不过去了。', time: '2小时前', likes: 328 },
      { id: 'c2', user: '后期打工人', stance: '反方', content: '做过剪辑的都懂，时长不是想加就能加，素材和节奏都有限制。', time: '3小时前', likes: 412 },
      { id: 'c3', user: '只看热闹', stance: '中立', content: '两边都有道理，说到底还是没有一个公开的标准。', time: '4小时前', likes: 156 },
    ],
  },
  {
    id: 'drama-script-adaptation',
    title: '热播剧台词改编引讨论：原著粉与剧粉观点碰撞',
    category: '影视综艺',
    categorySlug: 'screen',
    heat: 1456800,
    summary:
      '改编自同名小说的热播剧本周更新，几处关键台词被改写，引发原著读者与剧集观众的观点碰撞。讨论逐渐延伸到"影视化改编该保留多少原作"这一老话题。',
    tags: ['改编剧', '原著', '台词', '争议'],
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20open%20book%20pages%20turning%20into%20flowing%20light%20ribbons%20in%20warm%20red%20and%20gold%20palette%20on%20cream%20background%2C%20minimal%20artistic%20illustration%2C%20no%20text&width=800&height=500&seq=topic-drama-adapt-01&orientation=landscape',
    publishedAt: '2026-09-10',
    evolveHours: 40,
    stats: { support: 38, oppose: 47, neutral: 15 },
    timeline: [
      { time: '09-09 21:00', text: '剧集更新，两处经典段落台词与原作差异被观众截图对比。' },
      { time: '09-10 08:00', text: '原著读者发起讨论，话题登上热榜。' },
      { time: '09-10 16:00', text: '编剧在采访中回应改编取舍，强调需适配镜头语言。' },
      { time: '09-10 23:00', text: '讨论升温，出现"尊重原作"与"改编自由"两派观点。' },
    ],
    viewpoints: [
      { side: '正方', title: '关键台词应尊重原作', desc: '认为被改动的正是原作情绪浓度最高的段落，改动削弱了人物动机。' },
      { side: '反方', title: '改编需要再创作', desc: '认为小说与影视是两种媒介，直接照搬台词未必适合表演与节奏。' },
      { side: '中立', title: '看改得好不好', desc: '认为不能一概而论，改动如果更贴合剧情可以接受，关键看是否立得住。' },
    ],
    comments: [
      { id: 'c1', user: '书虫七年', stance: '正方', content: '那一段是全书的高光，改掉之后人物整个人都单薄了。', time: '1小时前', likes: 289 },
      { id: 'c2', user: '追剧不看书', stance: '反方', content: '我没看过原著，只觉得剧情挺顺的，先别急着下定论。', time: '5小时前', likes: 341 },
    ],
  },
  {
    id: 'concert-refund-rule',
    title: '演唱会退票规则调整：观众权益讨论持续升温',
    category: '娱乐八卦',
    categorySlug: 'entertainment',
    heat: 1264300,
    summary:
      '多家演出主办方近期更新退票与转赠规则，部分场次缩短了免费退票窗口。规则变化在观众群体中引发讨论，焦点集中在"退票自由"与"防黄牛"之间的平衡。',
    tags: ['演出', '退票', '规则', '消费者'],
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20concert%20stage%20lights%20and%20bokeh%20particles%20in%20warm%20coral%20and%20amber%20tones%20on%20dark%20cream%20gradient%2C%20minimal%20editorial%20style%2C%20no%20text&width=800&height=500&seq=topic-concert-ticket-01&orientation=landscape',
    publishedAt: '2026-09-09',
    evolveHours: 52,
    stats: { support: 51, oppose: 36, neutral: 13 },
    timeline: [
      { time: '09-08 10:00', text: '多个场次更新购票页面，退票窗口与转赠规则出现变化。' },
      { time: '09-08 19:00', text: '观众在社交平台交流不同场次规则差异。' },
      { time: '09-09 11:00', text: '主办方回应称调整主要为打击囤票与黄牛行为。' },
      { time: '09-09 20:00', text: '讨论转向"如何既防黄牛又保障普通观众"。' },
    ],
    viewpoints: [
      { side: '正方', title: '退票应当更灵活', desc: '认为临时有事无法到场很常见，规则收紧会增加观众风险成本。' },
      { side: '反方', title: '严格规则有其必要', desc: '认为此前宽松规则被黄牛利用，收紧是现实选择。' },
      { side: '中立', title: '需要分类管理', desc: '建议对个人退票与批量转售区别对待，而非一刀切。' },
    ],
    comments: [
      { id: 'c1', user: '看演出上瘾', stance: '正方', content: '提前一个月买票，临时有事退不了，这换谁都难受。', time: '6小时前', likes: 377 },
      { id: 'c2', user: '抢票失败组', stance: '反方', content: '宽松的时候根本抢不到，收紧一点也许票能好买些。', time: '7小时前', likes: 264 },
    ],
  },
  {
    id: 'live-commerce-quality',
    title: '直播带货货不对板？消费者评价出现两极分化',
    category: '网络消费',
    categorySlug: 'consumer',
    heat: 1098500,
    summary:
      '某场直播间的日用商品收到大量评价，一部分消费者称赞性价比，另一部分认为实物与讲解存在差距。争议集中在"直播间描述与实物一致"这一常被讨论的话题。',
    tags: ['直播带货', '消费', '评价', '售后'],
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20shopping%20parcels%20and%20warm%20ribbon%20shapes%20in%20orange%20and%20cream%20tones%2C%20minimal%20flat%20illustration%2C%20soft%20geometric%20composition%2C%20no%20text&width=800&height=500&seq=topic-live-selling-01&orientation=landscape',
    publishedAt: '2026-09-08',
    evolveHours: 33,
    stats: { support: 44, oppose: 41, neutral: 15 },
    timeline: [
      { time: '09-07 21:00', text: '该场直播销量走高，后续评价陆续发布。' },
      { time: '09-08 09:00', text: '部分买家晒出实物图，与直播间展示进行对比。' },
      { time: '09-08 15:00', text: '商家回应支持无理由退换，称已在详情页标注规格。' },
      { time: '09-08 22:00', text: '讨论转向直播间展示规范与消费者预期管理。' },
    ],
    viewpoints: [
      { side: '正方', title: '实物确实有落差', desc: '认为直播间灯光与讲解容易放大预期，收到货后落差感明显。' },
      { side: '反方', title: '价格摆在那里', desc: '认为商品本身有明确的规格说明，价格对应品质，属正常范围。' },
      { side: '中立', title: '售后是关键', desc: '认为买到不合适的很正常，关键在于退货流程是否顺畅。' },
    ],
    comments: [
      { id: 'c1', user: '购物车清空', stance: '正方', content: '直播里看着挺精致的，收到确实一般，还好能退。', time: '8小时前', likes: 198 },
      { id: 'c2', user: '理性买买买', stance: '反方', content: '详情页写得清清楚楚，自己没看规格怪谁呢。', time: '9小时前', likes: 233 },
    ],
  },
  {
    id: 'ai-face-swap',
    title: 'AI换脸特效刷屏：版权与伦理边界被反复追问',
    category: '科技数码',
    categorySlug: 'tech',
    heat: 968700,
    summary:
      '一款可将静态照片生成动态表情的工具在社交平台走红，用户用它制作趣味短片。随着传播扩大，关于素材授权、肖像使用与二次传播边界的讨论明显增多。',
    tags: ['AI', '换脸', '版权', '伦理'],
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20digital%20face%20grid%20made%20of%20glowing%20particles%20in%20orange%20and%20teal%20accents%20on%20cream%20background%2C%20minimal%20futuristic%20composition%2C%20no%20text&width=800&height=500&seq=topic-ai-face-01&orientation=landscape',
    publishedAt: '2026-09-07',
    evolveHours: 61,
    stats: { support: 35, oppose: 48, neutral: 17 },
    timeline: [
      { time: '09-06 12:00', text: '工具相关作品在短视频平台集中出现，播放量快速上升。' },
      { time: '09-06 20:00', text: '有创作者反映自己的素材被他人用于训练或二次加工。' },
      { time: '09-07 10:00', text: '平台发布提示，呼吁用户上传素材前确认授权。' },
      { time: '09-07 18:00', text: '讨论扩展到深度合成内容的标注与传播规范。' },
    ],
    viewpoints: [
      { side: '正方', title: '技术进步不该被限制', desc: '认为工具本身中立，用途广泛，重点是规范使用而非否定技术。' },
      { side: '反方', title: '边界需要先划定', desc: '认为涉及肖像与版权的合成内容一旦滥用，追责困难，应提前明确规则。' },
      { side: '中立', title: '标注与授权并行', desc: '建议合成内容统一标注，同时完善素材授权确认流程。' },
    ],
    comments: [
      { id: 'c1', user: '科技观察笔记', stance: '正方', content: '工具就是工具，坏人用菜刀干坏事也不能怪菜刀。', time: '12小时前', likes: 176 },
      { id: 'c2', user: '版权小卫士', stance: '反方', content: '拍的照片被拿去随便合成，换谁能开心？必须先授权。', time: '14小时前', likes: 305 },
    ],
  },
  {
    id: 'marathon-quota',
    title: '城市马拉松名额分配再起波澜：抽签机制被吐槽',
    category: '体育赛事',
    categorySlug: 'sports',
    heat: 843200,
    summary:
      '一场热门城市马拉松公布中签结果，大量跑者反映连续多年未中签。围绕抽签机制透明度的讨论升温，焦点在于"公平抽签"与"成绩优先"之间如何取舍。',
    tags: ['马拉松', '抽签', '名额', '跑步'],
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20running%20track%20lines%20curving%20through%20warm%20orange%20sunrise%20gradient%20on%20cream%20background%2C%20minimal%20sporty%20poster%20style%2C%20no%20text&width=800&height=500&seq=topic-marathon-01&orientation=landscape',
    publishedAt: '2026-09-06',
    evolveHours: 28,
    stats: { support: 47, oppose: 39, neutral: 14 },
    timeline: [
      { time: '09-05 15:00', text: '赛事公布中签结果，社交平台出现大量未中签反馈。' },
      { time: '09-05 22:00', text: '跑者整理历年抽签数据，讨论重复中签与长期未中的情况。' },
      { time: '09-06 11:00', text: '组委会说明抽签流程，强调随机性与监督机制。' },
      { time: '09-06 19:00', text: '讨论转向名额分配比例与抽签透明度。' },
    ],
    viewpoints: [
      { side: '正方', title: '应向老跑者倾斜', desc: '认为长期坚持跑步的爱好者应获得更多机会，成绩与出勤可作为参考。' },
      { side: '反方', title: '随机才是最公平', desc: '认为任何加权都会引入主观因素，纯随机反而最能让新人参与。' },
      { side: '中立', title: '公开数据即可', desc: '建议公开抽签过程与统计数据，让机制可被验证即可缓解质疑。' },
    ],
    comments: [
      { id: 'c1', user: '跑了五年', stance: '正方', content: '五年一次都没中，真的会让人心态崩。', time: '16小时前', likes: 421 },
      { id: 'c2', user: '佛系跑者', stance: '反方', content: '抽签本来就是看运气，中不了下次再来，别太较真。', time: '18小时前', likes: 187 },
    ],
  },
  {
    id: 'creator-traffic-change',
    title: '短视频平台流量分配调整：创作者群体反应不一',
    category: '科技数码',
    categorySlug: 'tech',
    heat: 762400,
    summary:
      '多个创作者反映近期作品播放量出现波动，平台回应称推荐机制进行了阶段性优化。围绕"算法是否更偏向某类内容"的讨论在创作者社区展开。',
    tags: ['平台', '算法', '创作者', '流量'],
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20rising%20bar%20chart%20and%20flowing%20data%20lines%20in%20warm%20orange%20and%20teal%20palette%20on%20cream%20background%2C%20minimal%20infographic%20style%2C%20no%20text&width=800&height=500&seq=topic-traffic-algo-01&orientation=landscape',
    publishedAt: '2026-09-05',
    evolveHours: 44,
    stats: { support: 33, oppose: 51, neutral: 16 },
    timeline: [
      { time: '09-04 10:00', text: '多位创作者发文分享播放量变化，话题在社区扩散。' },
      { time: '09-04 18:00', text: '同一领域创作者数据对比被整理成表格传播。' },
      { time: '09-05 09:00', text: '平台回应称推荐机制阶段性调优，用于提升内容匹配度。' },
      { time: '09-05 16:00', text: '讨论转向平台规则透明度与创作者权益保障。' },
    ],
    viewpoints: [
      { side: '正方', title: '调整会伤害中小创作者', desc: '认为流量波动对粉丝量不大的创作者影响最大，创作积极性受挫。' },
      { side: '反方', title: '算法优化有客观依据', desc: '认为平台需兼顾用户体验，规则调整是常态，不必过度解读。' },
      { side: '中立', title: '需要更透明的说明', desc: '建议平台公开更多机制说明与申诉渠道，减少创作者的不确定感。' },
    ],
    comments: [
      { id: 'c1', user: '小博主日常', stance: '正方', content: '上个月还稳定几千，这个月直接断崖，真的不知道该拍什么了。', time: '1天前', likes: 268 },
      { id: 'c2', user: '内容老玩家', stance: '反方', content: '算法一直都在变，与其抱怨不如研究内容本身。', time: '1天前', likes: 154 },
    ],
  },
  {
    id: 'anonymous-wall-boundary',
    title: '高校匿名社区内容边界之争：自由表达与隐私保护如何两全',
    category: '社会观察',
    categorySlug: 'society',
    heat: 691500,
    summary:
      '部分高校校内匿名社区因内容管理问题被讨论，学生群体中形成不同看法：有人认为是重要的表达出口，也有人担心匿名环境下的言语伤害与隐私风险。',
    tags: ['匿名社区', '表达', '隐私', '校园'],
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20speech%20bubbles%20overlapping%20in%20warm%20orange%20and%20teal%20shades%20on%20soft%20cream%20background%2C%20minimal%20editorial%20illustration%2C%20no%20text&width=800&height=500&seq=topic-campus-voice-01&orientation=landscape',
    publishedAt: '2026-09-04',
    evolveHours: 37,
    stats: { support: 45, oppose: 40, neutral: 15 },
    timeline: [
      { time: '09-03 12:00', text: '校内匿名社区一则内容引发争议，相关截图外传。' },
      { time: '09-03 20:00', text: '学生就匿名社区的价值与风险展开讨论。' },
      { time: '09-04 10:00', text: '校方与学生组织就内容管理方式征求意见。' },
      { time: '09-04 18:00', text: '讨论转向实名与匿名的边界设计。' },
    ],
    viewpoints: [
      { side: '正方', title: '匿名是必要的表达出口', desc: '认为匿名能让人更放心地表达真实想法，尤其是涉及权益的话题。' },
      { side: '反方', title: '匿名放大伤害', desc: '认为缺少约束的表达容易演变为针对个人的攻击，需要更强的管理。' },
      { side: '中立', title: '设计分级机制', desc: '建议对内容分级管理，敏感话题引入调解与核实流程。' },
    ],
    comments: [
      { id: 'c1', user: '图书馆常客', stance: '正方', content: '有些话只有匿名才敢说，把出口堵死了反而更糟。', time: '2天前', likes: 209 },
      { id: 'c2', user: '匿名有代价', stance: '反方', content: '自由不等于随便，匿名之后对人的伤害更难追责。', time: '2天前', likes: 246 },
    ],
  },
];